
import { getBoxValue } from './Const/functions';
import { getTypoCSS, getColorsCSS } from '../../Components/utils/getCSS';

const Style = ({ attributes, clientId }) => {
	const { columnGap, rowGap, btnTypo, btnWidth, btnHeight, btnAlign, btnColors, btnHovColors, btnPadding, btnBorder, btnRadius, btnSpaceBetween } = attributes;

	const newStyles = `
	${getTypoCSS('', btnTypo)?.googleFontLink}
	${getTypoCSS(`#lbbLightBox-${clientId} .lbbLightBox button`, btnTypo)?.styles}

	#lbbLightBox-${clientId} .lbbLightBox{
		grid-gap: ${rowGap} ${columnGap};
		justify-content:${btnAlign}; 
	}

	#lbbLightBox-${clientId} .lbbLightBox a{
		width:${btnWidth};
		height:${btnHeight};
	}
	
	#lbbLightBox-${clientId} .lbbLightBox.llbButton .flex{
		 justify-content: ${btnAlign}
	}

	#lbbLightBox-${clientId} .lbbLightBox button{
		${getColorsCSS(btnColors)};
		padding:${getBoxValue(btnPadding)};
		border:${getBoxValue(btnBorder)};
		column-gap:${btnSpaceBetween};
		border-radius:${(getBoxValue(btnRadius))};
		width:100%;
		height:100%;
	}
	
	#lbbLightBox-${clientId} .lbbLightBox button:hover{
		${getColorsCSS(btnHovColors)};
	}
`;

	return <style dangerouslySetInnerHTML={{
		__html: newStyles
	}} />;
}
export default Style;